module.exports = __webpack_public_path__ + "static/media/21.a10f8613.png";